export const socialAccounts = {
  card: {
    description: 'Connect your LinkedIn account so Referent can publish on your behalf.',
    personalScopeBadge: 'Personal connection',
    personalScopeHint:
      'This one is yours alone: unlike the other integrations on this page, it is not shared with the rest of your organization.',
    disconnectedHint: 'LinkedIn stopped accepting this connection. Reconnect to restore publishing.',
    erroredHint:
      'The connection service is having a temporary problem on its side. It retries automatically — no action needed.',
    pausedHint: 'This connection is paused due to a subscription issue. Our team is on it.',
    unnamedAccount: 'LinkedIn account',
    viewProfile: 'View profile',
  },

  status: {
    connected: 'Connected',
    disconnected: 'Session expired',
    errored: 'Service interruption',
    paused: 'Paused',
    notConnected: 'Not connected',
    unknown: 'Unknown status',
  },

  actions: {
    connect: 'Connect',
    reconnect: 'Reconnect',
    redirecting: 'Redirecting…',
    disconnect: 'Disconnect',
    dismiss: 'Dismiss',
    tryAgain: 'Try again',
    checkAgain: 'Check again',
  },

  returnBanner: {
    waiting: 'Finishing your LinkedIn connection… this usually takes a few seconds.',
    connected: 'Your LinkedIn account is connected.',
    failed: 'We could not complete the LinkedIn connection.',
    timedOut: 'This is taking longer than expected. Your connection may still be on its way.',
  },

  errorState: {
    title: 'We could not load your LinkedIn connection.',
    retry: 'Retry',
  },

  toast: {
    connectFailed: 'We could not start the LinkedIn connection. Please try again.',
    disconnected: 'LinkedIn account disconnected.',
    disconnectFailed: 'We could not disconnect your LinkedIn account. Please try again.',
  },
}
